const CONDUCCO_LOGO_PATHS: string[] = [
  '/authentications',
  '/cofre-digital',
  '/themes/preview',
  '/themes/edit',
  '/themes/configure',
  '/themes',
]

export { CONDUCCO_LOGO_PATHS }
